import React, { Component } from "react";
import { Line } from "react-chartjs-2";
import api from "../../../../api";

class CanvasBar extends Component {
 constructor(props) {
 super(props);

 this.state = {
 chartData: {
 labels: [],
 first: [],
 second: []
 },
 };
 }

 componentDidMount() {
 this.fetchWorkOrders();
 }

 // Fetch Work Orders
 fetchWorkOrders = async () => {
 try {
 const res = await api.get("/work-orders");

 if (res.data.success) {
 const workOrders = res.data.data;

 // Count by status
 const statusCount = {
 Pending: 0,
 Approved: 0,
 Rejected: 0,
 Procured: 0,
 "Partially Procured": 0,
 };

 workOrders.forEach((wo) => {
 if (statusCount[wo.status] !== undefined) {
 statusCount[wo.status]++;
 }
 });

 const labels = Object.keys(statusCount);
 const values = Object.values(statusCount);

 this.setState({
 chartData: {
 labels,
 first: values,
 second: values.map((v) => Math.round(v * 0.6)) // second dataset for the graph
 },
 });
 }
 } catch (error) {
 console.error("Failed to load work orders", error);
 }
 };

 render() {
 const { labels, first, second } = this.state.chartData;

 const data = {
 labels: labels,
 datasets: [
 {
 label: "Work Orders",
 backgroundColor: "rgba(82, 177, 65, 0)",
 borderColor: "#3FC55E",
 data: first,
 borderWidth: 6,
 tension: 0.4,
 },
 {
 label: "Comparison",
 backgroundColor: "rgba(255, 142, 38, 0)",
 borderColor: "#4955FA",
 data: second,
 borderWidth: 6,
 tension: 0.4,
 },
 ],
 };

 const options = {
 responsive: true,
 maintainAspectRatio: false,
 plugins: {
 legend: { display: false },
 },
 elements: { point: { radius: 0 } },
 scales: {
 y: {
 ticks: { color: "#6E6E6E", font: { size: 14 } },
 },
 x: {
 grid: { display: false },
 ticks: { color: "#6E6E6E", font: { size: 14 } },
 },
 },
 };

 return (
 <div style={{ minHeight: "235px" }}>
 <Line
 data={data}
 width={this.props.width || 433}
 height={this.props.height || 300}
 options={options}
 />
 </div>
 );
 }
}

export default CanvasBar;
